import { render } from "./HorseColorTable.vue?vue&type=template&id=0b78f41f"
import script from "./HorseColorTable.vue?vue&type=script&lang=js"
export * from "./HorseColorTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__